<template>

  <div id="unitTypeManage">
    <div class="dialog-content">
 
      <div v-if="editing" class="context">To edit a unit type, change the fields you wish to update and click save.</div>
      <div v-else class="context">To make a new unit type, enter a title, square footage, number of bedrooms, number of bathrooms and a description.</div>

      <!-- PROPERTY -->
      <v-text-field label="Property" prepend-icon="mdi-domain" v-model="property.name" disabled></v-text-field>

      <!-- TITLE -->
      <v-text-field :rules="rules.title" ref="inputTitle" label="Title" prepend-icon="mdi-format-title" v-model.trim="unitType.name"></v-text-field>

      <div style="margin-left: 40px">

        <!-- SQUARE FOOT -->
        <v-text-field :rules="rules.sqrft" ref="inputSqrft" label="Square Foot" :type="numberInputType" v-model.trim="unitType.sqrft"></v-text-field>

        <!-- BEDROOMS -->
        <v-text-field :rules="rules.bedrooms" ref="inputBedrooms" label="Bedrooms" :type="numberInputType" prepend-icon="" v-model="unitType.bedrooms"></v-text-field>

        <!-- BATHROOMS -->
        <v-text-field :rules="rules.bathrooms" ref="inputBathrooms" label="Bathrooms" :type="numberInputType" prepend-icon="" v-model="unitType.bathrooms"></v-text-field>

        <!-- DESCRIPTION -->
        <v-text-field :rules="rules.description" ref="inputDescription" multi-line rows="3" label="Description" no-resize prepend-icon="" maxlength="2000" v-model="unitType.description"></v-text-field>
    
      </div>
    </div>
    <div class="dialog-footer">
      <v-btn class="button" flat color="info" @click="routeRemoveQueries(['dialog', 'dialogAction', 'dialogItem'])">Cancel</v-btn>
      <v-btn class="button" flat color="primary" @click="editing ? save() : create()">{{ editing ? 'Save' : 'Create' }}</v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        editing: null,
        property: null,
        unitType: {
          name: '',
          bathrooms: 0,
          bedrooms: 0,
          sqrft: 0,
          description: ''
        },
        rules: {
          title: [
            function (e) {
              return !window.regex.title.test(e) ? 'Please enter a valid title.' : true;
            }
          ],
          sqrft: [
            function (e) {
              return (e && !window.regex.number.test(e)) ? 'Please enter a number.' : true;
            }
          ],
          bedrooms: [
            function (e) {
              return (e && !window.regex.number.test(e)) ? 'Please enter a number.' : true;
            }
          ],
          bathrooms: [
            function (e) {
              return (e && !window.regex.number.test(e)) ? 'Please enter a number.' : true;
            }
          ],
          description: [
            function (e) {
              return e.length > 0 && !window.regex.title.test(e) ? 'Please enter a valid description.' : true
            }
          ]
        }
      }
    },

    computed: {
      
      numberInputType () {
        return (window.cordova && window.cordova.platformId.toLowerCase() === 'ios') ? 'text' : 'number';
      }

    },
    
    props: {
      lockout: {

      },
      dialogComponent: {

      }
    },

    methods: {

      create () {
        var valid = this.validate();
        
        if (!valid) {
          Toast.show('Please correct the highlighted fields.');
          this.lockout.on = false;
          return;
        }

        this.$store.dispatch('createUnitType', {
          property: this.property._id,
          unitType: this.unitType
        })
        .then(data => {
          this.app.pages.properties.unitTypes.list.addItem(data._id, {unshift: true});
          this.routeRemoveQueries(['dialog', 'dialogAction', 'dialogItem']);
          
          // Reinit Filters to reflect changes
          window.AppData.initFilters();

          Toast.show('Unit Type created.', 'success');
          this.lockout.on = false;        
        })
        .catch(e => {
          Toast.showError(e);
          console.log(e);
        });

      },

      save () {
        this.lockout.on = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted fields.');
          this.lockout.on = false;
          return;
        }

        this.$store.dispatch('updateUnitType', {
          property: this.property._id,
          unitType: this.unitType
        })
        .then(data => {
          this.routeRemoveQueries(['dialog', 'dialogAction', 'dialogItem']);
          
          // Reinit Filters to reflect changes
          window.AppData.initFilters();

          Toast.show('Unit Type updated.', 'success');
          this.lockout.on = false;        
        })
        .catch(e => {
          Toast.showError(e);
          console.log(e);
        });
      },

      validate () {
        this.$refs.inputTitle.validate(true);
        this.$refs.inputSqrft.validate(true);
        this.$refs.inputBathrooms.validate(true);
        this.$refs.inputBedrooms.validate(true);
        this.$refs.inputDescription.validate(true);
      
        return (this.$refs.inputTitle.valid && this.$refs.inputSqrft.valid && this.$refs.inputBathrooms.valid && this.$refs.inputBedrooms.valid && this.$refs.inputDescription.valid);
      }

    },

    created () {
      this.editing = this.$route.query.dialogAction && this.$route.query.dialogAction === 'edit';
      this.property = this.$store.getters.property(this.app.pages.properties.selected);

      if (this.editing) {
        var unitType = this.$store.getters.unitType(this.$route.query.dialogItem);
        this.unitType = {
          _id: unitType._id,
          name: unitType.name,
          sqrft: unitType.sqrft,
          bathrooms: unitType.bathrooms,
          bedrooms: unitType.bedrooms,
          description: unitType.description
        }
      }

      this.title = this.editing ? 'Update Unit Type' : 'Create Unit Type'; 
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #unitTypeManage {
    position: relative;

    .dialog-content {
      padding: 16px;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/UnitTypeManage.vue